import { api_instance_auth } from ".";

export const GetHeatMapData = async ({ dateFilter, statesCodes, network }) => {
  try {
    // Ensure dateFilter is a string and apply lowercase transformation
    const date = dateFilter.toString().toLowerCase();

    // API Call
    const response = await api_instance_auth.post(`/get-heatmap-data`, {
      dateFilter: date,
      statesCode: statesCodes,
      type: network
    });

    return response;
  } catch (error) {
    console.error("Error in GetHeatMapData:", error.message);
    throw error; // Re-throw to handle errors outside this function
  }
};
